<notify-popup
  *ngIf="showLangNotify"
  [okLabel]="null"
  [cancelLabel]="'Ok'"
  (onChanged)="hideNotify()"
  [msg]="'ASelect.UseEnglishInput' | translate">
</notify-popup>

<div class="a-select-location"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.has-select]="selectedItem">

  <div class="a-select-location__optional" *ngIf="isOptional">{{ 'ASelect.Optional' | translate }}</div>

  <div class="a-select-location__inner" 
    [class.is-disabled]="isDisabled || control.disabled"
    [class.has-value]="!isMultiple && control.value"
    [class.has-error]="control.invalid && isSubmitted">
    
    <div class="a-select-location__items-bg" *ngIf="showItems" (click)="showDropdown(false)"></div>
    <div class="a-select-location__items" @slideInOut
      *ngIf="showItems"
      [class.open-top]="openPositionTop">
      <div class="a-select-location__items-inner is-scroll" #scrolledEl>
        <div class="a-select-location__item"
          *ngFor="let item of (searchVariants$ | async); let i = index;" 
          [id]="'a-select-item-id-' + i"
          [class.is-active]="isMultiple 
            ? selectedItem && selectedItem.length ? selectedItem.includes(item.value) : false
            : selectedItem ? item.value === selectedItem : false"
          (click)="selectItem(item);">
          {{ item.value }}
        </div>
      </div>
      <div class="a-select-location__nothing" 
        *ngIf="(searchVariants$ | async) && (searchVariants$ | async).length === 0 
          && (searchInput$ | async) && (searchInput$ | async) !== ''">
        {{ 'ASelect.NothingFound' | translate }}
      </div>
      <div class="a-select-location__nothing" 
        *ngIf="(searchVariants$ | async) && (searchVariants$ | async).length === 0 
          && (!(searchInput$ | async) || (searchInput$ | async) === '')">
        {{ 'ASelect.StartTyping' | translate }}
      </div>
    </div>

    <div class="a-select-location__input-box">
      <input #selectEl
        placeholder=" "
        type="text"
        [ngModel]="searchValue"
        (input)="inputValidator($event)"
        (focus)="onFocus()" 
        [disabled]="isSelectionDisabled"
        [attr.aria-disabled]="isSelectionDisabled"
        (blur)="onBlurAction()">
      <label>{{ label }}</label>
      <i class="app-ico-mask app-ico-mask__x" 
        *ngIf="hasClear && control.value && !isSelectionDisabled" 
        (click)="clear()">
      </i>
      <i class="app-ico-mask app-ico-mask__select-arrow-down" 
        [class.is-open]="showItems"
        (click)="showDropdown(showItems ? false : true); showItems && selectEl.focus();">
      </i>
    </div>
  </div>
  
  <div class="a-select-location__selected" *ngIf="isMultiple && selectedItems.length">
    <div class="a-select-location__selected__item" *ngFor="let item of selectedItems">
      {{ item }} <i class="app-ico-mask app-ico-mask__x" *ngIf="!isSelectionDisabled" (click)="removeSelected(item)"></i>
    </div>
  </div>

  <div class="a-input a-input__error-text" @opacityInOut
    *ngIf="control.invalid && isSubmitted && errorMessage">
    {{ errorMessage }}
  </div>

</div>
